import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newYorkCityConfig } from "./data";

export default function NewYorkCityPage() {
  return <CityPageTemplate config={newYorkCityConfig} />;
}